module.exports = __webpack_public_path__ + "img/areas2.1c1bcff5.png";